import type { RequestTypeKey } from '@shared/types';
import { RequestSource, RequestType } from '@features/requests/types';

// Re-export the shared type alias for backwards compatibility with feature
// imports (e.g. `import type { RequestTypeKey } from '@features/requests/utils'`).
export type { RequestTypeKey };

/**
 * Maps an API `RequestSource` to its UI category (`RequestType`), used for
 * label/icon/color lookups. Grouping:
 * - VACATION / HOLIDAYS / WEEKEND → VACATION
 * - PAID_LEAVE → PAID_LEAVE
 * - WISH → SHIFT_PREFERENCE
 */
export function getRequestTypeKey(source: RequestSource): RequestTypeKey {
    switch (source) {
        case RequestSource.VACATION:
        case RequestSource.HOLIDAYS:
        case RequestSource.WEEKEND:
            return RequestType.VACATION;
        case RequestSource.PAID_LEAVE:
            return RequestType.PAID_LEAVE;
        case RequestSource.WISH:
            return RequestType.SHIFT_PREFERENCE;
        default:
            return RequestType.VACATION;
    }
}
